import { EmptyModel, EmptyModelProps, EmptyRenderer } from '@mail/3promo';
import { LocalStorageStore } from '@mail/3promo/stores/localStorage';
import type { ModelCreator } from '@mail/3promo/types';
import { IS_PHONE_BROWSER } from 'reactApp/appHelpers/configHelpers';
import {
    closeLimitModal as closeLimit,
    PROMO_MODAL_ID,
    showIntervalModal as showInterval,
    showLimitModal as showLimit,
    storageKeyForModal,
} from 'reactApp/appHelpers/featuresHelpers/features/aiPhotoImproving';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { UserQuotaSelectors } from 'reactApp/modules/userQuota/userQuota.selectors';
import { store as reduxStore } from 'reactApp/store';
import { renderAiPhotoImprovingModal } from 'reactApp/ui/AiPhotoImprovingPromo/AiPhotoImprovingModal';

export const aiPhotoImprovingModalCreator: ModelCreator = ({ models, stores }) =>
    new EmptyModel(
        PROMO_MODAL_ID,
        models.base,
        new EmptyModelProps(PROMO_MODAL_ID, {
            store: new LocalStorageStore(storageKeyForModal, stores.localStorage),
            renderer: new EmptyRenderer(PROMO_MODAL_ID),
            closable: true,
            showLimit,
            closeLimit,
            showInterval,
            templateData: {},
            ignoreTestOnRedraw: true,
            test: (resolve, reject) => {
                // Только десктоп
                if (IS_PHONE_BROWSER) {
                    reject();
                    return;
                }

                const state = reduxStore.getState();
                const storage = getCurrentStorage(state);

                // Показываем только в хомяке и в галерее
                if (!(storage === EStorageType.home || storage === EStorageType.gallery)) {
                    reject();
                    return;
                }

                const isBizUser = UserSelectors.isBizUser(state);
                const isPaidUser = UserSelectors.isPaidUser(state);
                const isOverquota = UserQuotaSelectors.isOverquota(state);
                const isCorp = UserSelectors.isCorpUser(state);

                // Не показываем бизам, корпам, платникам и оверквотерам
                if (isBizUser || isPaidUser || isCorp || isOverquota) {
                    reject();
                    return;
                }

                resolve();
            },

            onShow: () => {
                renderAiPhotoImprovingModal();
            },
        })
    );
